import axios from 'axios'

export function portVCCForm(data) {
  return axios({
    method: 'POST',
    url: 'api/sales-static/vccf',
    data,
  })
}
